import React from 'react'
import INFTSalesList from '../../../models/INFTSalesList'
import { INFTMyWalletOnSale } from '../../../models/INFTProfile'
import NFTMarketItem from '../../Market/components/NFTMarketItem'
import styled from 'styled-components'

const WalletOnSale = styled.div`
  .sale-title {
    margin-bottom: 0.5rem;
    font-size: 1.2rem;
    font-weight: bold;
  }
  .sale-list {
    display: flex;
    flex-wrap: wrap;

    .nft-card-view {
      margin-right: 0.5rem;

      &:nth-child(4n) {
        margin-right: 0;
      }
    }
  }
`

export default function NFTMyWalletOnSale({ onSaleList, getSalesNFTItems, account }: INFTMyWalletOnSale) {
  return (
    <WalletOnSale>
      <div className="sale-list">
        {onSaleList.map((item: INFTSalesList) => (
          <NFTMarketItem
            key={`${item.id}_${item.tokenContract}_WALLET`}
            item={item}
            getSalesNFTItems={getSalesNFTItems}
            account={account}
          />
        ))}
      </div>
    </WalletOnSale>
  )
}
